import store from '../store/store'

import {
    Loading
} from 'element-ui';
export const helpers = {
    data() {
        return {}
    },
    computed: {},
    methods: {
        handle_function_call(methodName, args) {
            var self = this
            self[methodName](args)
        },
        showLoadingIndicator() {
            let loadingOptions = {
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
                refs: "selectCobrand"
            };
            this.loadingInstance = Loading.service(loadingOptions);
        },
        hideLoadingIndicator() {
            this.loadingInstance.close();
        },
        showToastMessage(msg) {
            store.state.componentStore.yToastMessage = {
                value: true,
                type: 'success',
                message: msg
              }
        },
    }
}